import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NotificationService } from 'app/_services/notification.service';
import { TrainingService } from 'app/_services/training.service';

@Component({
  selector: 'app-resend-induction-reminder-modal',
  templateUrl: './resend-induction-reminder-modal.component.html',
})
export class ResendInductionReminderModalComponent implements OnInit, AfterViewInit {
  @Input() workerFirstName: string;
  @Input() siteName: string;
  @Input() defaultMessage: string;
  @Input() skylarkUserId: number;
  @Input() courseId: number;
  @Input() workerEmail: string;
  @Output() sendingStateChange = new EventEmitter<boolean>();
  @Output() reminderSent = new EventEmitter<void>();
  @ViewChild('reminderMessageInput', { static: true }) messageInput: ElementRef<HTMLInputElement>;

  public messageControl = new FormControl('', [Validators.required, this.noWhitespaceValidator]);
  public isSending = false;

  constructor(
    public activeModal: NgbActiveModal,
    private trainingService: TrainingService,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {
    this.messageControl.setValue((this.defaultMessage || '').trim());
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.messageInput && this.messageInput.nativeElement) {
        const element = this.messageInput.nativeElement;
        element.focus();
        element.setSelectionRange(element.value.length, element.value.length);
      }
    });
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  public submit() {
    if (this.messageControl.invalid) {
      this.messageControl.markAsTouched();
      return;
    }

    this.setSendingState(true);

    const body = {
      skylarkUserId: this.skylarkUserId,
      courseId: this.courseId,
      message: this.messageControl.value.trim(),
    };

    const email = this.workerEmail || 'worker';

    this.trainingService.resendInductionReminder(body).subscribe(
      () => {
        this.setSendingState(false);
        this.notificationService.notify('success', 'Induction reminder sent to ' + email);
        this.reminderSent.emit();
        this.activeModal.close('sent');
      },
      () => {
        this.setSendingState(false);
        this.notificationService.notify('danger', 'Error', 'Failed to resend induction reminder to ' + email);
      }
    );
  }

  private setSendingState(isSending: boolean) {
    this.isSending = isSending;
    this.sendingStateChange.emit(isSending);
  }

  private noWhitespaceValidator(control: FormControl) {
    if (control.value === null || control.value === undefined) {
      return { whitespace: true };
    }

    return control.value.trim().length ? null : { whitespace: true };
  }
}
